import { useQuery } from '@ts-core/lib/apollo';

import { getErrorMessage } from '@ts-core/lib/apollo';
import { DataFetcherHookResult } from '@ts-core/core/types';

import { StudentAnsweredAssignment } from '@ts-core/modules/assignments/types';

import {
  getAssignmentDetailsQuery,
  GetAssignmentDetailsQueryResult,
  GetAssignmentDetailsQueryVariables,
} from '../graphql/queries/getAssignmentDetailsQuery';

export interface AssignmentDetailsHookInput {
  courseId: string;
  assignmentId: string;
}

type AnsweredAssignmentHookResult = DataFetcherHookResult<StudentAnsweredAssignment, 'assignment'>;

export default function useAssignmentDetails(input: AssignmentDetailsHookInput): AnsweredAssignmentHookResult {
  const { courseId, assignmentId } = input;
  const { data, loading, error } = useQuery<GetAssignmentDetailsQueryResult, GetAssignmentDetailsQueryVariables>(getAssignmentDetailsQuery, {
    variables: { courseId, assignmentId },
    fetchPolicy: 'cache-and-network',
  });

  return {
    assignment: data?.assignment,
    loading,
    error: getErrorMessage({ error }),
  };
}
